import React from 'react';
import styles from './index.module.less';

export function Mphone(props) {
    return <>mphone</>
}